import { render, staticRenderFns } from "./addRiskDialog.vue?vue&type=template&id=1e2788d7&scoped=true"
import script from "./addRiskDialog.vue?vue&type=script&lang=js"
export * from "./addRiskDialog.vue?vue&type=script&lang=js"
import style0 from "./addRiskDialog.vue?vue&type=style&index=0&id=1e2788d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2788d7",
  null
  
)

export default component.exports